export function getPxInInches(containerWidth, viewPortWidth) {
  const widthPx = containerWidth / viewPortWidth;
  return Math.floor(widthPx * 100) / 100;
}

export function inchesToPxs(inches, pxInInches) {
  return inches * pxInInches;
}